import { render, staticRenderFns } from "./LayoutLanding.vue?vue&type=template&id=4296f508&"
import script from "./LayoutLanding.vue?vue&type=script&lang=js&"
export * from "./LayoutLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports